import React from 'react'
import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import { Checkboxes } from 'mui-rff'
import QuestionHeader from './questionHeader'

const useStyles = makeStyles(() => ({
  checkbox: {
    '& .Mui-checked': {
      color: 'var(--button-color)'
    },
  },
}))

export default function RenderConfirmation(props) {
  const classes = useStyles()
  const { elmIndex, elm, valIndex, valueChange, allowModify } = props
  if (!elm.Value[valIndex]) elm.Value[valIndex] = ['']

  if (!elm.ConfirmationText) elm.ConfirmationText = 'Yes'

  const elmValueChange = (newVal) => { valueChange(elmIndex, valIndex, newVal ? [elm.ConfirmationText.trim()] : ['']) }
  const name = `elm-${elmIndex}-val-${valIndex}`
  const initialValues = {}
  initialValues[name] = elm.Value[valIndex][0]

  const options = [{ label: elm.ConfirmationText.trim(), val: elm.ConfirmationText.trim() }]

  return <div key={elmIndex} className={classes.checkbox}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    <Form onSubmit={() => { }}
      subscription={{}}
      initialValues={initialValues}
      //render={({ values }) => (<>
      render={() => (<>
        <Checkboxes name={name} variant="outlined" disabled={!allowModify} data={options} />
        <OnChange name={name}>
          {elmValueChange}
        </OnChange>
      </>)} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
    />
  </div>
}

RenderConfirmation.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}